import { render, staticRenderFns } from "./StrategiesCardRow.vue?vue&type=template&id=5f31e3e8&scoped=true"
import script from "./StrategiesCardRow.vue?vue&type=script&lang=js"
export * from "./StrategiesCardRow.vue?vue&type=script&lang=js"
import style0 from "./StrategiesCardRow.vue?vue&type=style&index=0&id=5f31e3e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31e3e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu})
